<div [formGroup]="playerSize" class="player-size">
    <targeting-container label="PLAYER SIZE" [hideRemove]="true" [hideEdit]="true" [disabled]="isDisabled">
        <div *ngFor="let size of playerSizeList" class="checkbox-container">
            <div class="checkbox-element">
                <acl-ngx-checkbox [label]="size.text" [checked]="size.exist" (onClick)="onChange($event, size.id)"
                    [disabled]="isDisabled">
                </acl-ngx-checkbox>
            </div>
        </div>
    </targeting-container>
</div>